// utils/notificationSound.js
export const playNotificationSound = () => {
    try {
        // Use absolute path from public folder
        const audio = new Audio(`/notification.mp3`);
        audio.volume = 0.5; // Set appropriate volume
        const playPromise = audio.play();

        if (playPromise !== undefined) {
            playPromise.catch(error => {
                console.log('Audio play failed:', error);
                // Fallback: Create and click a hidden button to enable audio
                enableAudioThroughInteraction();
            });
        }
    } catch (error) {
        console.log('Audio initialization failed:', error);
    }
};

// Fallback for browsers that require user interaction
const enableAudioThroughInteraction = () => {
    const btn = document.createElement('button');
    btn.style.display = 'none';
    btn.onclick = () => {
        playNotificationSound();
        document.body.removeChild(btn);
    };
    document.body.appendChild(btn);
    btn.click();
  };